import { uniq } from 'lodash';
import displayPrice from '../displayPrice';

const getPackagesFromUserWeeksSelection = (packages, offers, weeksSelection, isWeekend) => {
  let packagesList = [];
  if (offers && packages) {
    const offersFromSelectedWeeks = offers.filter((offer) => weeksSelection.includes(offer.weekId));
    const packagesIdsFromOffers = uniq(offersFromSelectedWeeks.map((offer) => offer.packageId));

    packagesList = packagesIdsFromOffers
      .map((id) => packages.find((p) => p.id === id))
      .filter((p) => p !== undefined)
      .filter((p) => (isWeekend
        ? (p.durationId === 2)
        : (p.durationId === 1 || p.durationId === 3)));

    // add offers to packages list
    packagesList = packagesList.map((pack) => ({
      ...pack,
      offers: offersFromSelectedWeeks.filter((offer) => offer.packageId === pack.id),
      otherOffers: offers.filter((offer) => (
        offer.packageId === pack.id
        && !Object.values(offersFromSelectedWeeks).some((val) => val.weekId === offer.weekId))),
    }));
  }

  return packagesList;
};

const populatePackageOffers = (pack, weeksSelection, offers) => {
  let populatedPack = { ...pack, offers: [] };

  if (offers?.length) {
    const offersFromSelectedWeeks = weeksSelection?.length
      ? offers.filter((offer) => weeksSelection.includes(offer.weekId))
      : [];

    populatedPack = {
      ...populatedPack,
      offers: offersFromSelectedWeeks.filter((offer) => offer.packageId === pack.id),
      otherOffers: offers.filter((offer) => (
        offer.packageId === pack.id
        && !Object.values(offersFromSelectedWeeks).some((val) => val.weekId === offer.weekId))),
    };
  }

  return populatedPack;
};

const getLowestOfferPrice = (offers) => {
  const lowest = offers.reduce((prev, current) => ((prev.campPrice < current.campPrice) ? prev : current), 0);
  return lowest ? displayPrice(lowest.campPrice / 100) : displayPrice(0);
};

const packageUtils = {
  getPackagesFromUserWeeksSelection,
  getLowestOfferPrice,
  populatePackageOffers,
};

export default packageUtils;
